<script setup lang="ts">
import { configDeliveryZones } from '@/storage/setting/configDeliveryZones'
import { toggleShowDeliveryZones } from '@/utils/order/toggleShowDeliveryZones'
import { ref } from 'vue'
import { formatPrice } from '@/event/locale'

const dropdownDeliveryZone = ref(configDeliveryZones.value.map(() => false))

function toggleDeliveryZone(index: any) {
    dropdownDeliveryZone.value[index] = !dropdownDeliveryZone.value[index]
}
</script>

<template>
    <section class="section-modal-delivery-zone-happy">
        <section
            class="section-modal-overlay-delivery-zone-happy"
            @click="toggleShowDeliveryZones()"
        ></section>

        <section class="section-modal-delivery-zone-content-happy">
            <div class="div-header-modal-delivery-zone-happy">
                <h3 class="header-modal-delivery-zone-happy">{{ $t('deliveryZones') }}</h3>
            </div>
            <div class="div-content-modal-delivery-zone-happy">
                <ul
                    class="ul-delivery-zone-happy"
                    v-for="(zone, index) in configDeliveryZones"
                    :key="index"
                >
                    <li class="li-delivery-zone-happy" @click="toggleDeliveryZone(index)">
                        {{ zone.city }}
                    </li>
                    <transition
                        name="delivery-zone"
                        enter-active-class="transition-all duration-300 ease-in-out"
                        enter-from-class="max-h-0 opacity-0"
                        enter-to-class="max-h-96 opacity-100"
                        leave-active-class="transition-all duration-300 ease-in-out"
                        leave-from-class="max-h-96 opacity-100"
                        leave-to-class="max-h-0 opacity-0"
                    >
                        <div
                            v-if="dropdownDeliveryZone[index]"
                            class="div-dropdown-content-happy"
                        >
                            <p>
                                - {{ $t('deliveryFee') }} :
                                {{ formatPrice(Number(zone.price)) }}
                            </p>
                            <p>
                                - {{ $t('minimumOrder') }} :
                                {{ formatPrice(Number(zone.minimum_price)) }}
                            </p>
                            <p v-if="Number(zone.free_price).toFixed(2) !== '0.00'">
                                - {{ $t('freeFrom') }} :
                                {{ formatPrice(Number(zone.free_price)) }}
                            </p>
                        </div>
                    </transition>
                </ul>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-modal-delivery-zone-happy {
    @apply fixed top-0 w-full h-full z-30 flex items-center justify-center;
}

.section-modal-overlay-delivery-zone-happy {
    /* refactored — bg-t-text her dark temada near-white (ör. ifo-dark #E6EDF3)
       olduğu için "dark overlay" niyetine rağmen krem/beyaz dim oluyordu.
       Siyah yarı saydam ile her temada gerçek karartma elde ediyoruz. */
    @apply w-full h-full bg-black/50;
}

.section-modal-delivery-zone-content-happy {
    /* refactored */
    @apply z-30 flex flex-col absolute border-2 rounded-lg max-w-[28rem] w-full overflow-hidden;
    @apply bg-t-accent border-t-accent;
    @apply happy-purple-gradient:bg-gradient-to-t happy-purple-gradient:to-bg-purple-dark happy-purple-gradient:from-bg-purple-light;
}

.div-header-modal-delivery-zone-happy {
    /* refactored */
    @apply flex bg-t-accent text-t-on-accent;
}

.header-modal-delivery-zone-happy {
    @apply uppercase font-semibold p-3;
}

.div-content-modal-delivery-zone-happy {
    /* refactored */
    @apply pl-7 pr-3 py-2 max-h-[32rem] w-full overflow-y-auto flex flex-wrap;
    @apply bg-t-card text-t-text;
}

.ul-delivery-zone-happy {
    @apply flex flex-col flex-wrap  w-full;
}

.li-delivery-zone-happy {
    @apply list-disc  w-full;
}
.li-delivery-zone-happy:active,
.li-delivery-zone-happy:focus {
    /* refactored */
    @apply font-semibold underline text-t-accent;
}
.div-dropdown-content-happy {
    @apply w-full;
}
.div-dropdown-content-happy:active,
.div-dropdown-content-happy:focus {
    /* refactored */
    @apply flex-wrap flex flex-col font-semibold text-t-accent;
}

@media (hover: hover) {
    .li-delivery-zone-happy:hover {
        /* refactored */
        @apply font-semibold underline text-t-accent;
    }
    .div-dropdown-content-happy:hover {
        /* refactored */
        @apply font-semibold text-t-accent;
    }
}
</style>
